import { CxAlertsService } from './../../../libs/components/cx-alerts/cx-alerts.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss']
})
export class LandingPageComponent implements OnInit {

  visibilitySuccsessAlert: boolean = false;
  visibilityWarnAlert: boolean = false;
  visibilityInfoAlert: boolean = false;

  messageSuccsessAlert: string = '';
  messageWarnAlert: string = '';
  messageInfoAlert: string = '';

  constructor(private alertService: CxAlertsService) { }

  ngOnInit(): void {
    
        /** Visibility **/
        this.alertService.visibilityAlertSuccess.subscribe(visibility => this.visibilitySuccsessAlert = visibility);
        this.alertService.visibilityAlertWarn.subscribe(visibility => this.visibilityWarnAlert = visibility);
        this.alertService.visibilityAlertInfo.subscribe(visibility => this.visibilityInfoAlert = visibility);
        /** Messages **/
        this.alertService.messageAlertSuccess.subscribe(message => this.messageSuccsessAlert = message);
        this.alertService.messageAlertWarn.subscribe(message => this.messageWarnAlert = message);
        this.alertService.messageAlertInfo.subscribe(message => this.messageInfoAlert = message);
  }

}
